<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import Checkbox from 'svelte-checkbox';
    import CommonButton from '@src/cross-reusable-components/buttons/common-button.svelte';
    import IconLevelVolume from '@src/components/icons/icon-level-volume.svelte';
    import { trackEvent } from '@root/src/utils/init-analytics.js';

    export let skipAgain;
    export let soundEnabled;

    const dispatch = createEventDispatcher();

    const toggleSound = () => {
        trackEvent('sound_change', {
            music_new_state: !soundEnabled ? 'on' : 'off',
            sound_new_state: !soundEnabled ? 'on' : 'off',
            change_origin: 'welcome_screen'
        });
        dispatch('toogle-mute', !!soundEnabled);
    };
</script>

<footer class="flex w-full flex-col items-center justify-end gap-2 desktop:gap-4">
    <CommonButton variants="primary" on:click={() => dispatch('close')}>CONTINUE</CommonButton>

    <div class="show-again relative z-10 mt-2 flex w-full items-center justify-center gap-2">
        <Checkbox
            class={`main__checkbox border-2 border-cross-n-400 ${skipAgain && 'bg-cross-bgrd-blue'}`}
            checked={skipAgain || false}
            name="show-again"
            primaryColor="#fff"
            secondaryColor="#000000"
            on:change={() => dispatch('skip-again', !skipAgain)}
        />

        <label for="show-again" class="text-xs font-bold uppercase text-cross-t-body">do not show again </label>

        <div class="sound absolute right-0 flex items-center justify-center">
            <button class="!h-8 !w-8 !cursor-pointer bg-transparent px-0" on:click={toggleSound}>
                {#if soundEnabled}
                    <IconLevelVolume />
                {:else}
                    <IconLevelVolume muted={true} />
                {/if}
            </button>
        </div>
    </div>
</footer>

<style>
    :global(.main__checkbox) {
        width: 24px !important;
        height: 24px !important;
        border-radius: 8px;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.24) inset;
        overflow: hidden;
    }

    :global(.checkbox__border) {
        stroke-width: 0 !important;
    }
</style>
